// extracted by mini-css-extract-plugin
export var HeroAreaLarge = "HeroAreaLarge-module--HeroAreaLarge--461b4";
export var description = "HeroAreaLarge-module--description--2855c";
export var image = "HeroAreaLarge-module--image--ae3bd";
export var seeAll = "HeroAreaLarge-module--seeAll--11f3a";
export var superTitle = "HeroAreaLarge-module--superTitle--58b35";
export var textContent = "HeroAreaLarge-module--textContent--00702";